import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.SeecSMSsServiceProxy,
        ApiServiceProxies.SeecEmailsServiceProxy,
        ApiServiceProxies.SeecEmailTemplatesServiceProxy,
        ApiServiceProxies.SeecSmsTemplatesServiceProxy,
        ApiServiceProxies.AttendeeInfosServiceProxy,
        ApiServiceProxies.TrainingRequestsServiceProxy,
        ApiServiceProxies.TrainingPackagesServiceProxy,
        ApiServiceProxies.CoursesServiceProxy,
        ApiServiceProxies.TopicsServiceProxy,
        ApiServiceProxies.AwarnessContentsServiceProxy,
        ApiServiceProxies.EfficiencyPlansServiceProxy,
        ApiServiceProxies.FormServiceProxy,
        ApiServiceProxies.VehicleInfosServiceProxy,
        ApiServiceProxies.GeneratorInfosServiceProxy,
        ApiServiceProxies.BuildingInfosServiceProxy,
        ApiServiceProxies.BuildingAssetInfosServiceProxy,
        ApiServiceProxies.StreetlightAssetInfosServiceProxy,
        ApiServiceProxies.FuelAssetInfosServiceProxy,
        ApiServiceProxies.MeterInfosServiceProxy,
        ApiServiceProxies.SecMetersReviewServiceProxy,
        ApiServiceProxies.EEPRequestDeadlineSettingServiceProxy,
        ApiServiceProxies.RequestPeriodSettingsServiceProxy,
        ApiServiceProxies.FuelProviderDetailsServiceProxy,
        ApiServiceProxies.FuelProviderDataServiceProxy,
        ApiServiceProxies.CustomAreaOfImprovementsServiceProxy,
        ApiServiceProxies.OrganizationEEPDetailsServiceProxy,
        ApiServiceProxies.OrganizationEEPsServiceProxy,
        ApiServiceProxies.OrganizationActivityDetailsServiceProxy,
        ApiServiceProxies.OrganizationActivityDetailsServiceProxy,
        ApiServiceProxies.OrganizationActivitiesServiceProxy,
        ApiServiceProxies.ElectricityComparisonServiceProxy,
        ApiServiceProxies.RequestServiceProxy,
        ApiServiceProxies.ProviderElectricitiesServiceProxy,
        ApiServiceProxies.CommonMethodsServiceProxy,
        ApiServiceProxies.GovElectricitiesServiceProxy,
        ApiServiceProxies.GovFuelsServiceProxy,
        ApiServiceProxies.SectorsServiceProxy,
        ApiServiceProxies.UserSectorsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.LookupServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.LookupServiceProxy,
        ApiServiceProxies.TeamMembersServiceProxy,
        ApiServiceProxies.FuelComparisonServiceProxy,
        ApiServiceProxies.FuelHistoricalConsumptionServiceProxy,
        ApiServiceProxies.ElectricityHistoricalConsumptionServiceProxy,
        ApiServiceProxies.OrgHistoricalConsumptionServiceProxy,
        ApiServiceProxies.ConsumptionComparisonReportServiceProxy,
        ApiServiceProxies.AboutSeecServiceProxy,
        ApiServiceProxies.NewsServiceProxy,
        ApiServiceProxies.MediaLibraryServiceProxy,
        ApiServiceProxies.FAQCategoryServiceProxy,
        ApiServiceProxies.FAQServiceProxy,
        ApiServiceProxies.ContactUsServiceProxy,
        ApiServiceProxies.ReferenceServiceProxy,
        ApiServiceProxies.ReopenRequestsServiceProxy,
        ApiServiceProxies.GovAwarnessContentPublicationServiceProxy,
        ApiServiceProxies.TrainingPackageRequestsServiceProxy,
        ApiServiceProxies.MediaCenterServiceProxy,
        ApiServiceProxies.UserSubmissionServiceProxy,
        ApiServiceProxies.KnowledgeBankServiceProxy,
        ApiServiceProxies.CoolingStationAssetInfosServiceProxy,
        ApiServiceProxies.AssetImportServiceProxy,
        ApiServiceProxies.ElectricityConsumptionReportServiceProxy,
        ApiServiceProxies.FuelConsumptionReportServiceProxy,
        ApiServiceProxies.BuildingEnergyEfficiencySubmissionsServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule { }
